export default __webpack_public_path__ + "static/1-blur-77aa262dfa5ce595d8a7e9abe4c5bc1d.png";